// Site-wide constants. The contact form now posts to the same-origin Vercel
// serverless function at /api/contact (Supabase + Resend) — the old axios
// client pointed at REACT_APP_BACKEND_URL (FastAPI/Mongo) is no longer used.

export const CALENDLY_URL = "https://calendly.com/sweety-aidify/30min";
export const PHONE_DISPLAY = "+1 646 595 1666";
export const PHONE_RAW = "+16465951666";
export const EMAIL = "info@aidify.us";

// WhatsApp uses a separate number
export const WHATSAPP_DISPLAY = "+1 (714) 509-0330";
export const WHATSAPP_RAW = "17145090330";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_RAW}?text=${encodeURIComponent("Hi aidify, I'd like to learn more about your services.")}`;

// Social media
export const SOCIALS = {
  linkedin: "https://www.linkedin.com/company/aidifyus/",
  instagram: "https://www.instagram.com/aidify.us/",
  twitter: "https://x.com/Aidify_us",
  facebook: "https://www.facebook.com/Aidify.us/",
};
